import { canAssumeTouchDevice } from 'shared/utils/touch_detection';
import documentReady from 'document-ready';
import classNames from 'classnames';
import { canAssumeMobileDevice } from './utils';

/**
 * For the sake of hiding desktop widget via CSS, add a class to the html element
 * to flag whether its a touch device or mobile-device not.
 *
 * The style is actually utilized in app/assets/stylesheets/availability.scss
 * */
export default function flagDeviceTypeOnDomReady() {
  documentReady(() => {
    document.querySelector('html').className += classNames({
      'touch-device': canAssumeTouchDevice(),
      'non-touch-device': !canAssumeTouchDevice(),
      'mobile-device': canAssumeMobileDevice(),
    });
  });
}
